import { render, staticRenderFns } from "./TheSidebarRightButton.vue?vue&type=template&id=7692290c&"
import script from "./TheSidebarRightButton.vue?vue&type=script&lang=js&"
export * from "./TheSidebarRightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBarNavIcon,VIcon})
